// extracted by mini-css-extract-plugin
export default {"container":"DocumentViewerSidebar_container__84FLi","buttonWrapper":"DocumentViewerSidebar_buttonWrapper__2t4l+"};